/**
 * CountriesOptions Component
 */
const CountriesOptions = () => {
  const countrySelectContainer = document.querySelector('.cmp-countriesoptions .cmp-countriesoptions__country')
  const stateSelectContainer = document.querySelector('.cmp-countriesoptions .cmp-countriesoptions__state')
  const customSelectOptionClass = '.c-custom-select-option'
  const CountryContainsState = 'data-contains-state'

  /**
   * Hide state select and zipcode. Also remove requiere attribute
   * @param {element} state state select
   */
  const hideState = state => {
    state.querySelector('select').value = ''
    state.querySelector('select').required = false
    state.querySelector('select').setAttribute('autocomplete', 'off')
    state.querySelector('select').disabled = true
    state.style.display = 'none'
    toggleZipCode(true)
  }

  /**
   *  Hide zip and mark as not requiered
   * @param {boolean} option true if zipCode must to be hidden
   */
  const toggleZipCode = option => {
    const zipCode = document.querySelector('input[name="zip"]')
    if (zipCode) {
      const zipCodeContainer = zipCode.parentNode.parentNode
      if (option) {
        zipCodeContainer.style.display = 'none'
        zipCode.required = false
      } else {
        zipCodeContainer.style.display = 'block'
        zipCode.required = true
      }
    }
  }

  /**
   *  Clone data-country attribute from state select to custom state select
   * @param {element} select state select
   */
  const cloneCountryValues = stateSelect => {
    const stateOptions = stateSelect.querySelectorAll('option')
    const customStateOptions = stateSelect.parentNode.querySelectorAll(customSelectOptionClass)

    // adding custom data-country to the new custom-select
    stateOptions.forEach((option, index) => {
      const country = option.dataset.country
      if (customStateOptions[index]) {
        customStateOptions[index].setAttribute('data-country', country)
      }
    })
  }

  const cloneCountryCodes = countrySelect => {
    const countryOptions = countrySelect.querySelectorAll('option')
    const customCountryOptions = countrySelect.parentNode.querySelectorAll(customSelectOptionClass)

    // adding custom data-country-code to the new custom-select
    countryOptions.forEach((option, index) => {
      const countryCode = option.dataset.countryCode
      if (customCountryOptions[index]) {
        customCountryOptions[index].setAttribute('data-country-code', countryCode)
      }
    })
  }

  /**
   *  When state select changes, then update custom state select
   * @param {element} select state select
   */
  const clearStateSelect = stateSelect => {
    stateSelect.addEventListener('change', function (event) {
      const selectedState = event.target.value
      if (selectedState !== '') {
        stateSelect.parentNode.classList.remove('is-empty')
      }
    })
  }

  /**
   *  When country select changes, then update custom country and state selects
   * @param {element, element} select country and state selects
   */
  const resetCustomSelects = (countrySelect, stateSelect) => {
    const cstSel = stateSelect.parentNode.customSelect
    cstSel.value = ''
    countrySelect.parentNode.classList.remove('is-empty')
    stateSelect.parentNode.classList.remove('is-empty')
  }

  /**
   *  When country select changes, then update state select options
   * @param {element, element} select country and state selects
   */
  const updateCountryValue = (countrySelect, stateSelect) => {
    const selectedCountry = countrySelect.value
    if (selectedCountry === '') {
      hideState(stateSelectContainer)
      return
    }

    resetCustomSelects(countrySelect, stateSelect)

    const selectedOption = countrySelect.querySelector('option[value="' + selectedCountry + '"]')
    updateStateValue(selectedCountry, selectedOption, stateSelect)
  }

  /**
   * Show zipCode and customStateSelect and show options for customStateSelect with the correct country
   * @param {string, element, element} select selectedOptionValue, selectedOption, stateSelect
   */
  const updateStateValue = (selectedCountry, selectedOption, stateSelect) => {
    if (selectedOption.getAttribute(CountryContainsState) === 'true') {
      stateSelectContainer.style.display = 'block'
      toggleZipCode(false)
      stateSelect.required = true
      stateSelect.removeAttribute('autocomplete')
      stateSelect.removeAttribute('disabled')

      // only display state of selected country
      const customStateOptions = stateSelect.parentNode.querySelectorAll(customSelectOptionClass)
      customStateOptions.forEach(function (state) {
        state.style.display = state.dataset.country === selectedCountry ? 'block' : 'none'
      })
    } else {
      // reset state value. hide everything.
      hideState(stateSelectContainer)
    }
    const defaultStateOptions = stateSelect.parentNode.querySelector('.c-custom-select-option-default')
    defaultStateOptions.setAttribute('disabled', selectedOption.getAttribute(CountryContainsState))
  }

  /**
   * initialize
   */
  const init = function () {
    if (stateSelectContainer && countrySelectContainer) {
      const countrySelect = countrySelectContainer.querySelector('select')
      const stateSelect = stateSelectContainer.querySelector('select')

      if (countrySelect && stateSelect) {
        toggleZipCode(true)
        cloneCountryCodes(countrySelect)
        cloneCountryValues(stateSelect)
        clearStateSelect(stateSelect)
        countrySelect.addEventListener('change', e => {
          this.updateCountryValue(e.target, stateSelect)
        })

        if (!sessionStorage.getItem('isPageLoaded')) {
          sessionStorage.setItem('isPageLoaded', 'true');
        }
        else{
          const customCountryChange = new Event("CustomCountryChange");
          countrySelect.addEventListener("CustomCountryChange", e => {
            const selectedOption = countrySelect.querySelector('option[value="' + e.target.value + '"]')
            if (selectedOption.getAttribute(CountryContainsState) === 'true') {
              const customStateOptions = stateSelect.parentNode.querySelectorAll(customSelectOptionClass)
              customStateOptions.forEach(function (state) {
              state.style.display = state.dataset.country === e.target.value ? 'block' : 'none'
              })
            } else {
              hideState(stateSelectContainer)
            }
          })
          countrySelect.dispatchEvent(customCountryChange);
        }
      }
    }
  }

  return {
    hideState,
    toggleZipCode,
    cloneCountryValues,
    clearStateSelect,
    resetCustomSelects,
    updateCountryValue,
    updateStateValue,
    init,
  }
}

export { CountriesOptions }
